import { usePermission } from "hooks/usePermission";
import { useAuth } from "context/AuthContext";
import { Navigate } from "react-router-dom";

const PermissionGuard = ({ permission, children }) => {
    const { isLoading } = useAuth();
    const hasPermission = usePermission(permission);

    if (isLoading || hasPermission === undefined) {
        return children;
    }
    if (!hasPermission) {
        return <Navigate to={'/unauthorized'}/>;
    }

    return children;
};

export default PermissionGuard;
